import axios from 'axios';
import apiUrls from '@/new-constants/apiUrls';

/**
 * Guarda una edición de la ficha. `vm` es el componente que edita: tiene que
 * tener `accommodation` y un <AdminAlcanceModal ref="alcance">.
 *
 *   1. pregunta si va solo a este alojamiento o a todos los del anfitrión,
 *   2. manda solo lo que cambió,
 *   3. pasa los valores nuevos de ESTE alojamiento al store (la ficha se
 *      actualiza sola) y avisa.
 *
 * Devuelve true si se guardó; false si se canceló o falló.
 */
export default async function guardarFicha(vm, cambios) {
    const id = vm.accommodation.idalojamiento;
    const alcance = await vm.$refs.alcance.preguntar(id);
    if (!alcance) return false;

    try {
        const { data } = await axios.post(apiUrls.backofficeAccommodationData(id), { alcance, ...cambios });
        vm.$store.dispatch('accommodation/setAccommodation', { ...vm.accommodation, ...data.datos });
        const n = Number(data.aplicados) || 1;
        aviso(vm, n > 1 ? vm.$t('admin_tools.toast.saved_all', { n }) : vm.$t('admin_tools.toast.saved'));
        if (data.traduccion === 'fallida') aviso(vm, vm.$t('admin_tools.toast.translate_failed'), 'warning');
        return true;
    } catch (err) {
        console.error('[Ficha admin] Error guardando', err);
        aviso(vm, vm.$t('admin_tools.toast.error'), 'danger');
        return false;
    }
}

export function aviso(vm, texto, variant = 'success') {
    vm.$bvToast.toast(texto, {
        title: vm.$t('admin_tools.title'),
        variant,
        solid: true,
        autoHideDelay: 3500,
        toaster: 'b-toaster-bottom-right',
    });
}
